/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldGroup } from './DatabaseFieldGroup';
import {
    DatabaseFieldGroupFromJSON,
    DatabaseFieldGroupFromJSONTyped,
    DatabaseFieldGroupToJSON,
} from './DatabaseFieldGroup';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseSettingsFilter } from './DatabaseSettingsFilter';
import {
    DatabaseSettingsFilterFromJSON,
    DatabaseSettingsFilterFromJSONTyped,
    DatabaseSettingsFilterToJSON,
} from './DatabaseSettingsFilter';
import type { DatabaseSettingsGroupingDescriptionsInner } from './DatabaseSettingsGroupingDescriptionsInner';
import {
    DatabaseSettingsGroupingDescriptionsInnerFromJSON,
    DatabaseSettingsGroupingDescriptionsInnerFromJSONTyped,
    DatabaseSettingsGroupingDescriptionsInnerToJSON,
} from './DatabaseSettingsGroupingDescriptionsInner';
import type { GespeicherteAuswertung } from './GespeicherteAuswertung';
import {
    GespeicherteAuswertungFromJSON,
    GespeicherteAuswertungFromJSONTyped,
    GespeicherteAuswertungToJSON,
} from './GespeicherteAuswertung';

/**
 * Additional settings for databases
 * @export
 * @interface DatabaseSettings
 */
export interface DatabaseSettings {
    /**
     * Diese UNTERdatenbank nicht in der Detailmaske ihrer Hauptdatenbank zeigen.
     * WOFUER: Ein Ticketsystem verweist auf seinen Sprint ueber ein Feld — die Liste der Sprints gehoert deshalb nicht noch einmal unter jedes Ticket. `hideChildDbView` am Elternteil blendet dagegen ALLE Unterdatenbanken aus; damit verschwaende auch die Verknuepfungs-Tabelle, die dort hingehoert.
     * DER SCHALTER STEHT AN DER UNTERDATENBANK, nicht am Elternteil: Wer eine Unterdatenbank anlegt, weiss, ob sie unten in der Maske erscheinen soll. Eine Ausnahmeliste am Elternteil liefe beim Umbenennen oder Verschieben auseinander.
     * Die Unterdatenbank bleibt vollstaendig erreichbar — ueber die Kinder-Ansicht, die Uebersicht und jeden Verweis auf sie.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    hideInParentDetails?: boolean;
    /**
     * Diese UNTERdatenbank nicht im Baustein „Datenbank-Menue" auffuehren.
     * WOFUER: Das Menue sammelt die Hauptdatenbank und ALLE Unterdatenbanken ein. Manche davon sind reine Zulieferer — die Sprint-Liste eines Ticketsystems etwa liefert nur die Auswahlwerte fuer ein Feld. Im Menue steht sie als gleichrangiger Einstiegspunkt und fuehrt in die Irre.
     * DER SCHALTER STEHT AN DER UNTERDATENBANK, wie sein Nachbar `hideInParentDetails`: Wer sie anlegt, weiss, wozu sie da ist. Eine Ausnahmeliste am Menue-Baustein muesste dagegen an JEDER Stelle gepflegt werden, an der ein Menue eingebaut ist.
     * AUSGEBLENDET IST NICHT GESPERRT: Die Unterdatenbank bleibt ueber ihre eigene Adresse, die Kinder-Ansicht und jeden Verweis auf sie vollstaendig erreichbar. Ihre eigenen Kinder bleiben im Menue stehen — verborgen wird der eine Eintrag, nicht die Familie.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    hideInDbMenu?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSettings
     */
    maxFileSizeInMb?: number;
    /**
     * optional category field id to group entries by
     * @type {string}
     * @memberof DatabaseSettings
     */
    groupBy?: string;
    /**
     * Kategoriefeld, dessen Auswahlmoeglichkeiten die SPALTEN der Kanban-Ansicht bilden. Ohne diese Angabe gibt es die Ansicht nicht: Ein Board ohne Spalten waere eine leere Flaeche, und welches Feld gemeint ist, kann die Anwendung nicht raten -- eine Datenbank hat oft mehrere Kategoriefelder.
     * EINE KARTE ZIEHEN SETZT DIESEN FELDWERT. Das Board ist damit keine eigene Datenhaltung, sondern eine andere Sicht auf ein Feld, das es ohnehin gibt: Was im Board verschoben wird, steht anschliessend genauso in der Liste und im Filter.
     * @type {string}
     * @memberof DatabaseSettings
     */
    kanbanFieldId?: string;
    /**
     * Optional: ein ZWEITES Kategoriefeld, auf dessen Wert das Board eingeschraenkt wird (zusammen mit `kanbanFilterValue`).
     * WOFUER: Ein Ticketsystem hat Phasen (Backlog, Planung, Sprint, Finalisiert) UND einen Bearbeitungsstand. Das Board soll die Spalten aus dem Stand bilden, aber nur die Tickets EINER Phase zeigen. Ohne diese Einschraenkung staende der ganze Themenspeicher im Board des laufenden Abschnitts.
     * @type {string}
     * @memberof DatabaseSettings
     */
    kanbanFilterFieldId?: string;
    /**
     * Der Wert, auf den `kanbanFilterFieldId` eingeschraenkt wird.
     * @type {string}
     * @memberof DatabaseSettings
     */
    kanbanFilterValue?: string;
    /**
     * Kategoriefeld, auf das die Datenbank beim OEFFNEN eingeschraenkt wird (zusammen mit `startFilterWert`).
     * WOFUER: Ein Ticketsystem soll im laufenden Abschnitt beginnen, nicht im ganzen Themenspeicher. Wer 300 Eintraege sieht, wo dreissig gemeint waren, filtert jedes Mal von Hand nach.
     * ES IST EINE VORBELEGUNG, KEINE SPERRE: Der Filter erscheint wie jeder andere als Pille in der Bedienleiste und laesst sich mit einem Klick wegnehmen. Ein Filter, den man nicht sieht und nicht loeschen kann, ist der schnellste Weg zu der Ueberzeugung, dass Daten fehlen.
     * @type {string}
     * @memberof DatabaseSettings
     */
    startFilterFeldId?: string;
    /**
     * Der Wert, auf den `startFilterFeldId` beim Oeffnen gesetzt wird.
     * @type {string}
     * @memberof DatabaseSettings
     */
    startFilterWert?: string;
    /**
     * sort entries by this field by default
     * @type {string}
     * @memberof DatabaseSettings
     */
    defaultSortBy?: string;
    /**
     * default sort direction
     * @type {string}
     * @memberof DatabaseSettings
     */
    defaultSortDirection?: DatabaseSettingsDefaultSortDirectionEnum;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseSettings
     */
    groupByFontSize?: DatabaseFontSizeEnum;
    /**
     * deprecated — moved to DatabaseAppearanceProperties.groupingFontColor
     * @type {string}
     * @memberof DatabaseSettings
     * @deprecated
     */
    groupByColor?: string;
    /**
     * deprecated — moved to DatabaseAppearanceProperties.groupingBackgroundColor
     * @type {string}
     * @memberof DatabaseSettings
     * @deprecated
     */
    groupByBackgroundColor?: string;
    /**
     * nutzung variant used for grouping (e.g. text, wert, icon)
     * @type {string}
     * @memberof DatabaseSettings
     */
    groupByVariant?: string;
    /**
     * hide the entry count displayed next to group headers in views
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    groupByHideCount?: boolean;
    /**
     * optional per-value description shown next to the grouping label in list view
     * @type {Array<DatabaseSettingsGroupingDescriptionsInner>}
     * @memberof DatabaseSettings
     */
    groupingDescriptions?: Array<DatabaseSettingsGroupingDescriptionsInner>;
    /**
     * 
     * @type {Array<DatabaseFieldGroup>}
     * @memberof DatabaseSettings
     */
    fieldGroups?: Array<DatabaseFieldGroup>;
    /**
     * 
     * @type {Array<DatabaseSettingsFilter>}
     * @memberof DatabaseSettings
     */
    filters?: Array<DatabaseSettingsFilter>;
    /**
     * Die Lesezeichen der Auswertung — gespeicherte Kreuztabellen.
     * WOFUER (Vorgabe des Betreibers 14.10.2026): „Die Auswertungen werden in einem neuen Fenster angezeigt. Koennte man diese Auswertungen als eine Art Lesezeichen speichern." Eine Auswertung stellt man selten einmal zusammen — wer sie monatlich braucht, waehlt sonst jedes Mal vier Felder neu.
     * AN DER DATENBANK UND FUER ALLE SICHTBAR, auf seine ausdrueckliche Wahl. Das unterscheidet sie vom GEDAECHTNIS des Dialogs (zuletzt eingestellte Auswertung), das im Browser des einzelnen Betrachters liegt: Jenes ist eine Gewohnheit, dieses eine Festlegung der Datenbank. Wer ein Lesezeichen loescht, loescht es damit auch fuer seine Kollegen.
     * @type {Array<GespeicherteAuswertung>}
     * @memberof DatabaseSettings
     */
    gespeicherteAuswertungen?: Array<GespeicherteAuswertung>;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    withHeaderRow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    withSumRows?: boolean;
    /**
     * Bei der Gruppierung nach einem KATEGORIEFELD MIT MEHRFACHAUSWAHL: Soll ein Eintrag unter JEDER gewaehlten Kategorie erscheinen?
     * AUS (Vorgabe, bisheriges Verhalten): Die gewaehlten Kategorien werden zu einem Text verbunden — "Webkonto, Kreditkarte" ist dann eine eigene, dritte Gruppe neben "Webkonto" und "Kreditkarte".
     * AN: Der Eintrag taucht in "Webkonto" UND in "Kreditkarte" auf; eine zusammengesetzte Gruppe entsteht nicht mehr.
     * WARUM ES EINEN SCHALTER BRAUCHT und nicht einfach das eine oder andere richtig ist (Vorgabe des Betreibers 28.08.2026): Beide Lesarten sind sinnvoll. "Welche Datensaetze haben genau diese Kombination" ist eine andere Frage als "welche Datensaetze betreffen Webkonten" — und wer die Kombination auswertet, dem zerfiele seine Gruppierung.
     * EIN EINTRAG ZAEHLT DANN MEHRFACH. Die Summe der Gruppengroessen ist groesser als die Zahl der Datensaetze. Das ist keine Doppelzaehlung aus Versehen, sondern die Folge der Frage — die Anzahl je Gruppe bleibt trotzdem richtig.
     * Fehlt der Wert, gilt AUS: Bestehende Datenbanken veraendern sich nicht von selbst.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    groupBySplitMulti?: boolean;
    /**
     * Den AUFRUF der Unterdatenbanken ausblenden — das letzte Symbol in der Werkzeugleiste, das in die Ansicht „Sub" fuehrt.
     * ZWEI FRAGEN, ZWEI SCHALTER: `hideChildDbView` versteckt die Unterdatenbanken in der DETAILMASKE eines Datensatzes. Bis zum 02.09.2026 tat derselbe Schalter beides; wer nur den Knopf loswerden wollte, verlor auch den Bereich in der Maske.
     * NICHT GESETZT HEISST „WIE BISHER": Ist das Feld leer, gilt `hideChildDbView`. Bestehende Datenbanken verhalten sich damit unveraendert — ohne Migration und ohne dass irgendwo ein Knopf wieder auftaucht, den jemand bewusst abgeschaltet hatte. Erst wer den neuen Schalter anfasst, trennt die beiden Fragen fuer diese Datenbank.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    hideChildDbNavigation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    hideChildDbView?: boolean;
    /**
     * Unterdatenbanken in der Detailmaske nur zeigen, wenn ihr NAME mit
     * dem Wert des unter `childDbMatchFieldId` gewaehlten Feldes
     * uebereinstimmt. Bei Kategoriefeldern mit Mehrfachauswahl zaehlt
     * jeder gewaehlte Wert. Ohne Treffer wird keine Unterdatenbank
     * angezeigt.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    showChildDbOnFieldMatch?: boolean;
    /**
     * Id des Feldes, dessen Wert mit dem Namen der Unterdatenbanken
     * verglichen wird. Nur wirksam, wenn `showChildDbOnFieldMatch` an ist.
     * @type {string}
     * @memberof DatabaseSettings
     */
    childDbMatchFieldId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    showPwaInstallButton?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    keyvisualInDetailView?: boolean;
    /**
     * Sum-Modus fuer das CostSummary-Template:
     * - snapshot: nur letzte Buchung pro Konto zaehlt (Vermoegen)
     * - flow: alle Buchungen werden summiert (Kosten/Cashflow)
     * @type {string}
     * @memberof DatabaseSettings
     */
    summenModus?: DatabaseSettingsSummenModusEnum;
    /**
     * Layout-Modus der Σ-Gesamt-Zeile im CostSummary-Template:
     * - standard: ein Wert je Spalte
     * - erweitert: in Betrag- und Prognose-Spalten zwei Werte
     *   (oberer/unterer) mit Tooltip
     * - cashflow: drei Werte je Spalte (Einnahmen/Ausgaben/Saldo
     *   im Betrag bzw. Ungeplant/Geplant/Forecast in der Prognose)
     * @type {string}
     * @memberof DatabaseSettings
     */
    sumRowMode?: DatabaseSettingsSumRowModeEnum;
    /**
     * Datumsfeld, das eine Abmeldung markiert (z.B. „Abgemeldet am").
     * Ist es gesetzt, nimmt POST /public/unsubscribe/{dbId} Abmeldungen
     * entgegen und traegt dort das Tagesdatum ein. BEWUSST ohne
     * Bestaetigungsklick: Eine Abmeldung muss einfach sein — zusaetzliche
     * Huerden sind hier weder gewuenscht noch rechtlich ratsam.
     * @type {string}
     * @memberof DatabaseSettings
     */
    unsubscribeFieldId?: string;
    /**
     * Opt-in: schaltet die oeffentliche Formular-Annahme
     * (POST /public/form/{dbId}) fuer diese Datenbank frei. Ohne das Flag
     * antwortet der Endpunkt mit 404 (verraet nichts ueber Existenz).
     * Beschreibbar sind nur Eingabe-Feldtypen; Datumsfelder bleiben
     * aussen vor, damit Formulare keine system-gesetzten Zeitstempel
     * (z.B. „Bestaetigt am") faelschen koennen.
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    publicFormEnabled?: boolean;
    /**
     * Opt-in: schaltet die oeffentlichen WBT-Endpunkte (/public/wbt/*) fuer
     * diese Datenbank frei. In der Vorlage „KI Wissen" gesetzt, vererbt sich
     * an jede daraus erstellte Kundendatenbank. Ohne dieses Flag antworten
     * die WBT-Endpunkte mit 404 (verraten nichts ueber Existenz).
     * @type {boolean}
     * @memberof DatabaseSettings
     */
    wbtEnabled?: boolean;
    /**
     * Optionale Ziel-Datenbank fuer die ANONYME Antwort-Statistik (eigene
     * Auswertungs-DB des Anbieters). Ist sie gesetzt, schreibt der submit-
     * Endpunkt je Frage richtig/falsch + Modul + Branche + Monat dorthin —
     * ohne Personenbezug. Fehlt sie, wird keine Statistik geschrieben.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtStatsDbId?: string;
    /**
     * Optionale Fragen-Quelle: DB, aus deren Kategoriefeldern (titlePhrase +
     * wert) der WBT-Endpunkt Fragen ausspielt und bewertet. So bleibt die
     * Kunden-DB schlank (nur Teilnehmer-Kartei), waehrend Fragen + Loesungs-
     * schluessel zentral in EINER Quelle des Anbieters liegen. Fehlt der
     * Verweis, nutzt der Endpunkt die Kunden-DB selbst (Fallback).
     * HINWEIS: Eine ID gilt nur in IHRER Umgebung. Beim Publish DEV->PROD
     * reist sie unveraendert mit und zeigt auf PROD ins Leere — deshalb
     * greift dann wbtQuestionDbRole (s.u.).
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtQuestionDbId?: string;
    /**
     * Umgebungsunabhaengiger Verweis auf die Statistik-Datenbank: gesucht
     * wird die DB, deren settings.wbtRole diesen Wert traegt — in der
     * jeweils LAUFENDEN Umgebung. Greift, wenn wbtStatsDbId fehlt oder dort
     * nicht aufloesbar ist (= nach einem Vorlagen-Publish DEV->PROD).
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtStatsDbRole?: string;
    /**
     * Umgebungsunabhaengiger Verweis auf die Fragen-Quelle: gesucht wird die
     * DB, deren settings.wbtRole diesen Wert traegt — in der jeweils
     * LAUFENDEN Umgebung. Greift, wenn wbtQuestionDbId fehlt oder dort nicht
     * aufloesbar ist (= nach einem Vorlagen-Publish DEV->PROD).
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtQuestionDbRole?: string;
    /**
     * Kennzeichnet DIESE Datenbank als benannte WBT-Quelle (z.B.
     * "ki-wissen-fragen" oder "ki-wissen-statistik"). Gegenstueck zu
     * wbtQuestionDbRole/wbtStatsDbRole. Pro Rolle sollte es je Umgebung
     * genau eine Datenbank geben; bei mehreren gewinnt die aelteste
     * (stabil, damit spaetere Kopien die Aufloesung nicht kapern).
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtRole?: string;
    /**
     * Welche Art WBT diese Datenbank ist. Ohne Angabe gilt "EXAM".
     * 
     * EXAM (bisher, „KI Wissen"): eine PRUEFUNG. Aus vielen Fragen wird
     * eine Auswahl gezogen, je Frage ist genau eine Antwort richtig, am
     * Ende steht bestanden oder nicht. Der Loesungsschluessel verlaesst
     * den Server nie.
     * 
     * AUDIT („AgenturAudit"): eine SELBSTEINSCHAETZUNG. ALLE Fragen
     * werden gestellt, jede Antwortstufe traegt 0 bis 3 Punkte, es gibt
     * kein Richtig und kein Bestehen. Je Kriterium entsteht ein Rohwert,
     * daraus der Wert auf der 18er-Skala und dessen Ampelfarbe.
     * 
     * BEWUSST EIN SCHALTER UND KEINE ZWEITE ENGINE AM SELBEN CODE: Die
     * beiden Modelle teilen nur die Anmeldung und den Fortschritt. Ihre
     * Bewertung ist gegenlaeufig — hier ein gehueteter Loesungsschluessel,
     * dort ein Katalog, den man mitsamt Punktwerten ausliefern darf, weil
     * sich niemand selbst betruegen kann.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtMode?: string;
    /**
     * Nur im AUDIT-Modus: Datenbank mit den Auswertungs-Textbausteinen
     * (je Kriterium einer fuer Rot, Gelb und Gruen). Sie liegen bewusst
     * als EINTRAEGE einer Datenbank und nicht im Code der Kursseite —
     * eine Formulierung zu aendern soll kein Hochladen erfordern.
     * Wie bei den anderen Verweisen gilt die ID nur in IHRER Umgebung;
     * nach einem Publish DEV->PROD greift wbtTextDbRole.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtTextDbId?: string;
    /**
     * Umgebungsunabhaengiger Verweis auf die Textbaustein-Datenbank:
     * gesucht wird die DB, deren settings.wbtRole diesen Wert traegt — in
     * der jeweils LAUFENDEN Umgebung. Greift, wenn wbtTextDbId fehlt oder
     * dort nicht aufloesbar ist.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtTextDbRole?: string;
    /**
     * Nur im AUDIT-Modus: Datenbank mit den KENNZAHL-DEFINITIONEN
     * (Formel, Datenquelle, Richtung, die fuenf Bandgrenzen). Sie ist das
     * Gegenstueck zum Fragenkatalog fuer die zweite Haelfte des
     * Erfolgsrads — dort wird nicht eingeschaetzt, sondern gemessen.
     * Wie bei den anderen Verweisen gilt die ID nur in IHRER Umgebung;
     * nach einem Publish DEV->PROD greift wbtKpiDbRole.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtKpiDbId?: string;
    /**
     * Umgebungsunabhaengiger Verweis auf die Kennzahlen-Datenbank:
     * gesucht wird die DB, deren settings.wbtRole diesen Wert traegt — in
     * der jeweils LAUFENDEN Umgebung. Greift, wenn wbtKpiDbId fehlt oder
     * dort nicht aufloesbar ist.
     * @type {string}
     * @memberof DatabaseSettings
     */
    wbtKpiDbRole?: string;
}


/**
 * @export
 */
export const DatabaseSettingsDefaultSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type DatabaseSettingsDefaultSortDirectionEnum = typeof DatabaseSettingsDefaultSortDirectionEnum[keyof typeof DatabaseSettingsDefaultSortDirectionEnum];

/**
 * @export
 */
export const DatabaseSettingsSummenModusEnum = {
    Snapshot: 'snapshot',
    Flow: 'flow'
} as const;
export type DatabaseSettingsSummenModusEnum = typeof DatabaseSettingsSummenModusEnum[keyof typeof DatabaseSettingsSummenModusEnum];

/**
 * @export
 */
export const DatabaseSettingsSumRowModeEnum = {
    Standard: 'standard',
    Erweitert: 'erweitert',
    Cashflow: 'cashflow'
} as const;
export type DatabaseSettingsSumRowModeEnum = typeof DatabaseSettingsSumRowModeEnum[keyof typeof DatabaseSettingsSumRowModeEnum];


/**
 * Check if a given object implements the DatabaseSettings interface.
 */
export function instanceOfDatabaseSettings(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSettingsFromJSON(json: any): DatabaseSettings {
    return DatabaseSettingsFromJSONTyped(json, false);
}

export function DatabaseSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hideInParentDetails': !exists(json, 'hideInParentDetails') ? undefined : json['hideInParentDetails'],
        'hideInDbMenu': !exists(json, 'hideInDbMenu') ? undefined : json['hideInDbMenu'],
        'maxFileSizeInMb': !exists(json, 'maxFileSizeInMb') ? undefined : json['maxFileSizeInMb'],
        'groupBy': !exists(json, 'groupBy') ? undefined : json['groupBy'],
        'kanbanFieldId': !exists(json, 'kanbanFieldId') ? undefined : json['kanbanFieldId'],
        'kanbanFilterFieldId': !exists(json, 'kanbanFilterFieldId') ? undefined : json['kanbanFilterFieldId'],
        'kanbanFilterValue': !exists(json, 'kanbanFilterValue') ? undefined : json['kanbanFilterValue'],
        'startFilterFeldId': !exists(json, 'startFilterFeldId') ? undefined : json['startFilterFeldId'],
        'startFilterWert': !exists(json, 'startFilterWert') ? undefined : json['startFilterWert'],
        'defaultSortBy': !exists(json, 'defaultSortBy') ? undefined : json['defaultSortBy'],
        'defaultSortDirection': !exists(json, 'defaultSortDirection') ? undefined : json['defaultSortDirection'],
        'groupByFontSize': !exists(json, 'groupByFontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['groupByFontSize']),
        'groupByColor': !exists(json, 'groupByColor') ? undefined : json['groupByColor'],
        'groupByBackgroundColor': !exists(json, 'groupByBackgroundColor') ? undefined : json['groupByBackgroundColor'],
        'groupByVariant': !exists(json, 'groupByVariant') ? undefined : json['groupByVariant'],
        'groupByHideCount': !exists(json, 'groupByHideCount') ? undefined : json['groupByHideCount'],
        'groupingDescriptions': !exists(json, 'groupingDescriptions') ? undefined : ((json['groupingDescriptions'] as Array<any>).map(DatabaseSettingsGroupingDescriptionsInnerFromJSON)),
        'fieldGroups': !exists(json, 'fieldGroups') ? undefined : ((json['fieldGroups'] as Array<any>).map(DatabaseFieldGroupFromJSON)),
        'filters': !exists(json, 'filters') ? undefined : ((json['filters'] as Array<any>).map(DatabaseSettingsFilterFromJSON)),
        'gespeicherteAuswertungen': !exists(json, 'gespeicherteAuswertungen') ? undefined : ((json['gespeicherteAuswertungen'] as Array<any>).map(GespeicherteAuswertungFromJSON)),
        'withHeaderRow': !exists(json, 'withHeaderRow') ? undefined : json['withHeaderRow'],
        'withSumRows': !exists(json, 'withSumRows') ? undefined : json['withSumRows'],
        'groupBySplitMulti': !exists(json, 'groupBySplitMulti') ? undefined : json['groupBySplitMulti'],
        'hideChildDbNavigation': !exists(json, 'hideChildDbNavigation') ? undefined : json['hideChildDbNavigation'],
        'hideChildDbView': !exists(json, 'hideChildDbView') ? undefined : json['hideChildDbView'],
        'showChildDbOnFieldMatch': !exists(json, 'showChildDbOnFieldMatch') ? undefined : json['showChildDbOnFieldMatch'],
        'childDbMatchFieldId': !exists(json, 'childDbMatchFieldId') ? undefined : json['childDbMatchFieldId'],
        'showPwaInstallButton': !exists(json, 'showPwaInstallButton') ? undefined : json['showPwaInstallButton'],
        'keyvisualInDetailView': !exists(json, 'keyvisualInDetailView') ? undefined : json['keyvisualInDetailView'],
        'summenModus': !exists(json, 'summenModus') ? undefined : json['summenModus'],
        'sumRowMode': !exists(json, 'sumRowMode') ? undefined : json['sumRowMode'],
        'unsubscribeFieldId': !exists(json, 'unsubscribeFieldId') ? undefined : json['unsubscribeFieldId'],
        'publicFormEnabled': !exists(json, 'publicFormEnabled') ? undefined : json['publicFormEnabled'],
        'wbtEnabled': !exists(json, 'wbtEnabled') ? undefined : json['wbtEnabled'],
        'wbtStatsDbId': !exists(json, 'wbtStatsDbId') ? undefined : json['wbtStatsDbId'],
        'wbtQuestionDbId': !exists(json, 'wbtQuestionDbId') ? undefined : json['wbtQuestionDbId'],
        'wbtStatsDbRole': !exists(json, 'wbtStatsDbRole') ? undefined : json['wbtStatsDbRole'],
        'wbtQuestionDbRole': !exists(json, 'wbtQuestionDbRole') ? undefined : json['wbtQuestionDbRole'],
        'wbtRole': !exists(json, 'wbtRole') ? undefined : json['wbtRole'],
        'wbtMode': !exists(json, 'wbtMode') ? undefined : json['wbtMode'],
        'wbtTextDbId': !exists(json, 'wbtTextDbId') ? undefined : json['wbtTextDbId'],
        'wbtTextDbRole': !exists(json, 'wbtTextDbRole') ? undefined : json['wbtTextDbRole'],
        'wbtKpiDbId': !exists(json, 'wbtKpiDbId') ? undefined : json['wbtKpiDbId'],
        'wbtKpiDbRole': !exists(json, 'wbtKpiDbRole') ? undefined : json['wbtKpiDbRole'],
    };
}

export function DatabaseSettingsToJSON(value?: DatabaseSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hideInParentDetails': value.hideInParentDetails,
        'hideInDbMenu': value.hideInDbMenu,
        'maxFileSizeInMb': value.maxFileSizeInMb,
        'groupBy': value.groupBy,
        'kanbanFieldId': value.kanbanFieldId,
        'kanbanFilterFieldId': value.kanbanFilterFieldId,
        'kanbanFilterValue': value.kanbanFilterValue,
        'startFilterFeldId': value.startFilterFeldId,
        'startFilterWert': value.startFilterWert,
        'defaultSortBy': value.defaultSortBy,
        'defaultSortDirection': value.defaultSortDirection,
        'groupByFontSize': DatabaseFontSizeEnumToJSON(value.groupByFontSize),
        'groupByColor': value.groupByColor,
        'groupByBackgroundColor': value.groupByBackgroundColor,
        'groupByVariant': value.groupByVariant,
        'groupByHideCount': value.groupByHideCount,
        'groupingDescriptions': value.groupingDescriptions === undefined ? undefined : ((value.groupingDescriptions as Array<any>).map(DatabaseSettingsGroupingDescriptionsInnerToJSON)),
        'fieldGroups': value.fieldGroups === undefined ? undefined : ((value.fieldGroups as Array<any>).map(DatabaseFieldGroupToJSON)),
        'filters': value.filters === undefined ? undefined : ((value.filters as Array<any>).map(DatabaseSettingsFilterToJSON)),
        'gespeicherteAuswertungen': value.gespeicherteAuswertungen === undefined ? undefined : ((value.gespeicherteAuswertungen as Array<any>).map(GespeicherteAuswertungToJSON)),
        'withHeaderRow': value.withHeaderRow,
        'withSumRows': value.withSumRows,
        'groupBySplitMulti': value.groupBySplitMulti,
        'hideChildDbNavigation': value.hideChildDbNavigation,
        'hideChildDbView': value.hideChildDbView,
        'showChildDbOnFieldMatch': value.showChildDbOnFieldMatch,
        'childDbMatchFieldId': value.childDbMatchFieldId,
        'showPwaInstallButton': value.showPwaInstallButton,
        'keyvisualInDetailView': value.keyvisualInDetailView,
        'summenModus': value.summenModus,
        'sumRowMode': value.sumRowMode,
        'unsubscribeFieldId': value.unsubscribeFieldId,
        'publicFormEnabled': value.publicFormEnabled,
        'wbtEnabled': value.wbtEnabled,
        'wbtStatsDbId': value.wbtStatsDbId,
        'wbtQuestionDbId': value.wbtQuestionDbId,
        'wbtStatsDbRole': value.wbtStatsDbRole,
        'wbtQuestionDbRole': value.wbtQuestionDbRole,
        'wbtRole': value.wbtRole,
        'wbtMode': value.wbtMode,
        'wbtTextDbId': value.wbtTextDbId,
        'wbtTextDbRole': value.wbtTextDbRole,
        'wbtKpiDbId': value.wbtKpiDbId,
        'wbtKpiDbRole': value.wbtKpiDbRole,
    };
}

